module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAwIiBoZWlnaHQ9IjYwMCIgdmlld0JveD0iMCAwIDEwIDYiPjxwYXRoIGQ9Ik0wIDBoMTB2NkgweiIgZmlsbD0iIzAwMmI3ZiIvPjxwYXRoIGQ9Ik0wIDFoMTB2NEgweiIgZmlsbD0iI2ZmZiIvPjxwYXRoIGQ9Ik0wIDJoMTB2MkgweiIgZmlsbD0iI2NlMTEyNiIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/cri.svg
// module id = g+3r
// module chunks = 0